module.exports = __webpack_public_path__ + "static/openspace-187114329fddb63708019508a20efcd1.png";